import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import CustomAlert from "../../shared/CustemAlert";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API;

export default function Add({ increment, counter }) {
  const [title, setTitle] = useState(""); // useState hook
  const [address, setAddress] = useState("");
  const [error, setError] = useState(false);
  const [isAdded, SetIsAdded] = useState(false);
  const axiosPrivate = useAxiosPrivate();

  // handle change event
  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    if (e.target.id === "title") setTitle(e.target.value);
    else setAddress(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let isMounted = true;
    const controller = new AbortController();

    const postData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "jobs/place/",
          {
            title: title.trim(),
            address: address.trim(),
          },
          {
            signal: controller.signal,
          }
        );
        setAddress("");
        SetIsAdded(true);
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    postData();
    setTitle("");
    setError(false);
  };
  // render

  return (
    <div>
      <center>
        <div className="card text-dark bg-light container p-3 border  ">
          <div className="card-header">
            <h2>מקומות וכתובות</h2>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <div className="form-group">
                    <label htmlFor="title">מקום</label>
                    <input
                      type="text"
                      name="title"
                      value={title}
                      onChange={handleChange}
                      className="form-control"
                      id="title"
                      placeholder="שם המקום"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="adrress">כתובת</label>
                    <textarea
                      rows="4"
                      cols="50"
                      name="address"
                      value={address}
                      onChange={handleChange}
                      className="form-control"
                      id="address"
                      placeholder="כתובת"
                    />
                  </div>
                  <br />
                  <button type="submit" className="btn btn-primary">
                    הוסף מקום חדש
                  </button>
                </form>
              </Col>
            </Row>

            {isAdded && (
              <CustomAlert
                setShow={SetIsAdded}
                alertHeader={title}
                alertBody="המקום נוסף בהצלחה"
              />
            )}
          </div>
        </div>
      </center>
    </div>
  );
}
